import React from 'react';
import { Banner } from './banner';
import { TumorBoard } from './tumorBoard';
import { WhyAxiona } from './whyAxiona';
import { Helmet } from "react-helmet";
import { useTranslation } from 'react-i18next';

export const Doctors = () => {
  const { t } = useTranslation('global');
  return(
    <>
    <Helmet>
            <title>{t('doctors.helmet-title')}</title>
            <meta 
              name='description'
              content='content'
            />
          </Helmet>
      <Banner />
      <WhyAxiona />
      <TumorBoard />
    </>
  );
}